import React from 'react';

import RouteLink from '@ivy/components/atoms/RouteLink';
import useWhitelabel from '@ivy/lib/whitelabel/useWhitelabel';
import WHITELABEL_CONFIGURATIONS from '@ivy/lib/whitelabel/whitelabelConfig';

const useAcepSectionTooltip = () => {
	const wl = useWhitelabel();
	const acepWl = WHITELABEL_CONFIGURATIONS.find((el) => el.name === 'acep')!;
	if (wl.name === acepWl.name) {
		return undefined;
	}
	return (
		<>
			This information comes from the employer questionnaire on{' '}
			<RouteLink
				to={{
					pathname: '/',
					whitelabel: 'acep',
				}}
				openInNewTab
			>
				{acepWl.productName}
			</RouteLink>
			.
		</>
	);
};

export default useAcepSectionTooltip;
